<template>
  <Transition name="item-group-modal-overlay">
    <div
      v-if="visible"
      class="item-group-modal-overlay item-group-modal-overlay--glass"
      @click.self="$emit('cancel')"
    >
      <Transition name="item-group-modal-panel" appear>
        <div
          v-if="visible"
          class="item-group-modal-card item-group-modal-card--glass"
          role="dialog"
          aria-modal="true"
          aria-labelledby="item-group-modal-title"
          @click.stop
        >
          <div class="item-group-modal-header item-group-modal-header--glass">
            <h2 id="item-group-modal-title" class="item-group-modal-title">
              {{ itemType ? `New ${itemType} Category` : 'New Category' }}
            </h2>
            <button
              type="button"
              class="item-group-modal-close-btn"
              aria-label="Close"
              title="Close"
              @click="$emit('cancel')"
            >
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>

          <div class="item-group-modal-body item-group-modal-body--glass">
            <LabelInputField
              input-id="item-group-name"
              label="Name"
              v-model="groupName"
              :placeholder="namePlaceholder"
              required
              flex
              :has-error="!!error"
              :disabled="saving"
              @input="error = ''"
            >
              <div v-if="error" class="item-group-modal-error">{{ error }}</div>
            </LabelInputField>
          </div>

          <div class="item-group-modal-actions item-group-modal-actions--glass">
            <SecondaryButton label="Cancel" :disabled="saving" @click="$emit('cancel')" />
            <PrimaryButton label="Save" :loading="saving" @click="ok" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>

  <ErrorModal
    :show="showErrorModal"
    title="Validation Error"
    :message="errorMessage"
    buttonText="OK"
    @close="closeErrorModal"
  />
</template>

<script>
import '../styles/AddNewItemGroup.css';
import CompanyService from '@/services/company.service.js';
import ErrorModal from '@/components/ErrorModal.vue';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'AddNewItemGroup',
  components: {
    ErrorModal,
    LabelInputField,
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
    /** 'Product' | 'Service' | 'Inventory'; null creates a category shown for every item type. */
    itemType: {
      type: String,
      default: null,
    },
  },
  computed: {
    namePlaceholder() {
      const examples = {
        Product: 'e.g. Consumable',
        Service: 'e.g. Maintenance',
        Inventory: 'e.g. Raw Material',
      };
      return examples[this.itemType] || 'e.g. Finished Good';
    },
  },
  data() {
    return {
      groupName: '',
      error: '',
      saving: false,
      showErrorModal: false,
      errorMessage: '',
    };
  },
  methods: {
    async ok() {
      if (!this.groupName.trim()) {
        this.error = 'Name field is required.';
        return;
      }
      this.saving = true;
      this.error = '';
      try {
        const group = await CompanyService.createItemGroup({
          name: this.groupName.trim(),
          companyId: this.companyId,
          itemType: this.itemType,
        });
        this.$emit('ok', group);
        this.groupName = '';
        this.error = '';
      } catch (err) {
        this.errorMessage = err.response?.data?.message || err.message || 'Failed to create category.';
        this.showErrorModal = true;
      } finally {
        this.saving = false;
      }
    },
    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
  },
};
</script>
